import { Component } from '@angular/core';
import { MenuButton } from 'src/app/shared/model/menu-button';
import { UserSettingsService } from '../settings/service/user-settings.service';
import { buildVehiclesConfigMenu } from './vehicles-config-menu';

@Component({
  selector: 'app-vehicles-nemu',
  templateUrl: './vehicles-menu.component.html',
  styleUrls: ['./vehicles-menu.component.scss']
})
export class VehiclesMenuComponent {

  readonly buttons: MenuButton[];
  constructor(public settings: UserSettingsService) {
    this.buttons = buildVehiclesConfigMenu(this.settings);
  }


}
